import React, { useEffect, useState, useMemo,  useRef } from "react";
import {
  Form,
  Button,
  Row,
  Col,
  Table,
  Modal,
} from "react-bootstrap";
import api from "../axiosConfig";
import { useNavigate } from "react-router-dom";

const GenerarMembrete = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // Clientes y búsqueda
  const [clientes, setClientes] = useState([]);
  const [filtroNombre, setFiltroNombre] = useState("");
  const [clientesFiltrados, setClientesFiltrados] = useState([]);
  const [filtroFecha, setFiltroFecha] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");

  // Formulario base
  const [form, setForm] = useState({ cliente_id: "", cita_id: "" });
  const [citas, setCitas] = useState([]);
  const [citasFiltradas, setCitasFiltradas] = useState([]);

  // Catalogos (NUEVO)
  const [estadosPago, setEstadosPago] = useState([]); // [{id, nombre}]
  const [tiposMembreteOpciones, setTiposMembreteOpciones] = useState([]); // [{id, nombre}]

  // Campos dependientes
  const [motivo, setMotivo] = useState("");

  // Ahora 'estado' es el ID del estado de pago
  const [estado, setEstado] = useState("");
  const [estadoPagoLote, setEstadoPagoLote] = useState("");

  // Ahora tiposMembrete es array de IDs
  const [tiposMembrete, setTiposMembrete] = useState([]);

  const [observaciones, setObservaciones] = useState("");

  // Direcciones (instituciones)
  const [direcciones, setDirecciones] = useState([]);
  const [direccionId, setDireccionId] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    nombre: "",
    direccion: "",
    estado_provincia: "",
    codigo_postal: "",
  });

  // Lote
  const [institucionIdLote, setInstitucionIdLote] = useState("");
  const [fechaLote, setFechaLote] = useState(new Date().toISOString().slice(0, 10));

  // Lista de membretes
  const [membretes, setMembretes] = useState([]);
  const [membreteEditando, setMembreteEditando] = useState(null);
  const [archivoGenerado, setArchivoGenerado] = useState(null);

  // Paginación / filtro
  const [pagina, setPagina] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const porPagina = 20;
  const [filtroMembrete, setFiltroMembrete] = useState("");

  // Para mapear estado desde pagos cuando llega como texto (pago/fiao/debe)
  const [estadoDesdePagoNombre, setEstadoDesdePagoNombre] = useState("");

  // Mapear estado de membretes para actualización automática
  const estadosMembretesRef = useRef({});

  // Helpers de catálogos
  const estadoIdPorNombre = (nombre) => {
    const e = estadosPago.find(
      (ep) => (ep.nombre || "").toLowerCase() === (nombre || "").toLowerCase()
    );
    return e?.id;
  };
  //alertas
  const [mensaje, setMensaje] = useState(null);
  const mostrarMensaje = (tipo, texto) => {
    setMensaje({ tipo, texto });
    setTimeout(() => setMensaje(null), 4000); // se oculta en 4s
  };

  const nombreEstado = (id) =>
    estadosPago.find((e) => e.id === id)?.nombre || "Sin estado";

  const nombreTipo = (id) =>
    tiposMembreteOpciones.find((t) => t.id === id)?.nombre || "Sin tipo";

  const esClienteInstitucion = (tipoId) => {
    const t = tiposMembreteOpciones.find((x) => x.id === tipoId);
    if (!t) return tipoId === 1; // fallback por si no está cargado aún
    const nom = (t.slug || t.nombre || "").toLowerCase();
    // heurística por nombre
    return (
      nom.includes("cliente") &&
      (nom.includes("institucion") || nom.includes("institución"))
    ) || tipoId === 1;
  };

  const esDebe = useMemo(() => {
    const obj = estadosPago.find((e) => e.id === parseInt(estado));
    return ((obj?.nombre || "").toLowerCase() === "debe");
  }, [estado, estadosPago]);

  // Cargas iniciales
  useEffect(() => {
    cargarClientes();
    cargarTodasLasCitas();
    cargarDirecciones();
    cargarCatalogos();
  }, []);

  const cargarCatalogos = async () => {
    try {
      // Ajusta estas rutas si tu backend las expone diferente
      const [respEstados, respTipos] = await Promise.all([
        api.get("/catalogos/estados-pago"),
        api.get("/catalogos/tipos-membrete"),
      ]);
      setEstadosPago(respEstados.data || []);
      setTiposMembreteOpciones(respTipos.data || []);
    } catch (err) {
      console.error("Error cargando catálogos:", err);
      setEstadosPago([]);
      setTiposMembreteOpciones([]);
    }
  };

  useEffect(() => {
    cargarMembretes();
  }, [pagina, filtroMembrete, filtroFecha, filtroTipo]);

  useEffect(() => {
    const filtrados = clientes.filter((c) =>
      `${c.nombres} ${c.apellidos}`.toLowerCase().includes(filtroNombre.toLowerCase())
    );
    setClientesFiltrados(filtrados);
  }, [filtroNombre, clientes]);

  const cargarEstadoDesdePago = async (cita_id, cliente_id) => {
    if (!cita_id || !cliente_id) {
      setEstado("");
      setEstadoDesdePagoNombre("");
      return;
    }
    try {
      const res = await api.get("/pagos/tipo-pago-por-cita-cliente", {
        params: { cita_id, cliente_id }
      });
      const tipoPagoId = res.data.tipo_pago; // "pago" | "fiao" | "debe"
      setEstadoDesdePagoNombre(tipoPagoId);
      if (tipoPagoId && !estado) {
      setEstado(String(tipoPagoId)); // Guardamos el ID directamente

       //  Aquí actualizamos la lista de membretes
      setMembretes(prev =>
        prev.map(m =>
          m.cita_id === parseInt(cita_id) && m.cliente_id === parseInt(cliente_id)
            ? { ...m, estado_pago_id: tipoPagoId }
            : m
        )
      );
      // Buscar el nombre en el catálogo `estadosPago`
      const estadoObj = estadosPago.find(e => e.id === tipoPagoId);
      setEstadoDesdePagoNombre(estadoObj ? estadoObj.nombre : "");
    } else {
      setEstado("");
      setEstadoDesdePagoNombre("");
    }
  } catch (error) {
    console.error("Error cargando estado desde pago:", error);
    setEstado("");
    setEstadoDesdePagoNombre("");
  }
};

  useEffect(() => {
    const citaSeleccionada = citas.find((c) => c.id === parseInt(form.cita_id));
    if (citaSeleccionada) {
      if (citaSeleccionada.motivo) {
        setMotivo(citaSeleccionada.motivo.nombre);
      } else if (citaSeleccionada.motivo_id) {
        api
          .get(`/motivos/${citaSeleccionada.motivo_id}`)
          .then((res) => setMotivo(res.data.nombre))
          .catch((err) => console.error(err));
      } else {
        buscarMotivoParaAcompanante(form.cliente_id);
      }
    }
    // Cargar estado desde pagos (ahora mapea a ID con catálogos)
    cargarEstadoDesdePago(form.cita_id, form.cliente_id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.cita_id, form.cliente_id]);

  const buscarMotivoParaAcompanante = async (clienteId) => {
    try {
      const res = await api.get(`/acompanantes/por-cliente/${clienteId}`);
      const acompanante = res.data.find((a) => a.cita_id === parseInt(form.cita_id));
      if (acompanante?.motivo_id) {
        const motivoRes = await api.get(`/motivos/${acompanante.motivo_id}`);
        setMotivo(motivoRes.data.nombre);
      }
    } catch (error) {
      console.error("No se pudo cargar motivo para acompañante", error);
    }
  };

  const cargarClientes = async () => {
    const res = await api.get("/clientes/");
    setClientes(res.data.resultados || []);
  };

  const cargarTodasLasCitas = async () => {
    const res = await api.get("/citas/");
    const añoActual = new Date().getFullYear();
    const citasDelAñoActual = (res.data.resultados || []).filter((cita) => {
      const añoCita = new Date(cita.fecha).getFullYear();
      return añoCita === añoActual;
    });
    setCitas(citasDelAñoActual);
  };

  const cargarDirecciones = async () => {
    const res = await api.get("/direcciones-envio/");
    setDirecciones(res.data || []);
  };

  const cargarCitasPorCliente = async (clienteId) => {
    try {
      
      const response = await api.get(`/citas/por-cliente/${clienteId}`);
      const añoActual = new Date().getFullYear();

      const citasDelAñoActual = (response.data || []).filter((cita) => {
       const añoCita = new Date(cita.fecha).getFullYear();
       return añoCita === añoActual;
      });
      setCitasFiltradas(citasDelAñoActual);
    } catch (error) {
      console.error("Error cargando citas del cliente:", error);
      setCitasFiltradas([]);
    }
  };

  const cargarMembretes = async () => {
    try {
      const skip = (pagina - 1) * porPagina;
      const res = await api.get("/membretes/", {
        params: {
          skip,
          limit: porPagina,
          buscar: filtroMembrete.trim() !== "" ? filtroMembrete : undefined,
          fecha: filtroFecha || undefined,
          tipo: filtroTipo || undefined,
        },
      });
      setMembretes(res.data.resultados || []);
       
      // Guardar estados en ref para polling  NUEVO REVISAR
      const mapEstados = {};
      (res.data.resultados || []).forEach(m => {
        mapEstados[m.id] = m.estado_pago_id;
      });
      estadosMembretesRef.current = mapEstados;


      const total = res.data.total || 0;
      setTotalPaginas(Math.max(1, Math.ceil(total / porPagina)));
    } catch (error) {
      console.error("Error al cargar membretes", error);
    }
  };


  const handleClienteSelectChange = async (e) => {
    const clienteId = e.target.value; 
    await cargarCitasPorCliente(clienteId);
    setForm({ ...form, cliente_id: clienteId, cita_id: "" });
  };

  const handleCrearDireccion = async () => {
    try {
      const res = await api.post("/direcciones-envio/", nuevaDireccion);
      setDirecciones((prev) => [...prev, res.data]);
      setDireccionId(res.data.id);
      setMostrarModal(false);
      setNuevaDireccion({ nombre: "", direccion: "", estado_provincia: "", codigo_postal: "" });
    } catch (error) {
      mostrarMensaje("danger", "Error al guardar dirección");
      console.error(error);
    }
  };

  //PROCESAR EN LOTE ZIP
 const handleProcesarLote = async (estadoPago) => {
  try {
    const params = new URLSearchParams();
    params.append("fecha", fechaLote);
    if (estadoPago) params.append("estado_pago", estadoPago);
    if (institucionIdLote) params.append("institucion_id", institucionIdLote);

    const token = localStorage.getItem("token");
    const res = await api.post(
      `/membretes/procesar-lote?${params.toString()}`,
      {},
      { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }
    );

    if (!res.data.size) {
      mostrarMensaje("warning", "No hay membretes para los filtros seleccionados.");
      return;
    }

    const blob = new Blob([res.data], { type: "application/zip" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `membretes_${fechaLote}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error procesando lote", error);
    mostrarMensaje("danger", error.response?.data?.detail || "No se pudo generar el lote");
  }
};

// PROCESAR EN LOTE PDF INDIVIDUAL
const handleDescargarPDFUnico = async () => {
  try {
    const params = new URLSearchParams();
    if (fechaLote) params.append("fecha", fechaLote);
    if (institucionIdLote) params.append("institucion_id", institucionIdLote);
    if (estadoPagoLote) params.append("estado_pago", estadoPagoLote);

    const token = localStorage.getItem("token");
    const res = await api.post(
      `/membretes/procesar-lote-pdf?${params.toString()}`,
      {},
      { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }
    );

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `membretes_lote_${fechaLote}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error(error);
    mostrarMensaje("danger", "No se pudo generar el PDF combinado");
  }
};

//generar membrete individual
  const handleGenerarMembrete = async () => {
  if (!form.cliente_id || !form.cita_id || !estado) {
    mostrarMensaje("warning", "Debe seleccionar cliente, cita y estado.");
    return;
  }

  const incluyeClienteInstitucion = tiposMembrete.some((id) => esClienteInstitucion(id));
  if (incluyeClienteInstitucion && !direccionId) {
    mostrarMensaje("warning", "Seleccione la Dirección/Institución para 'Cliente ➝ Institución'.");
    return;
  }

  const payload = {
    cliente_id: parseInt(form.cliente_id),
    cita_id: parseInt(form.cita_id),
    estado_pago_id: parseInt(estado),
    observaciones,
    tipos_membrete: tiposMembrete.map((id) => parseInt(id)),
    direccion_id: incluyeClienteInstitucion
      ? Number.isInteger(direccionId) ? direccionId : null
      : null,
    fecha: new Date().toISOString(),
  };

  setLoading(true);
  try {
    let res;

    if (membreteEditando) {
      // Edita un membrete existente
      res = await api.put(
        `/membretes/${membreteEditando.id}`,
        payload
      );
      mostrarMensaje("success", "Membrete actualizado correctamente");

      // Actualiza la lista reemplazando el membrete editado
      setMembretes(prev => prev.map(m =>
        m.id === res.data.id ? res.data : m
      ));

      // Actualiza ref de estados
      estadosMembretesRef.current[res.data.id] = res.data.estado_pago_id;
 
    } else {
      // Crea uno o varios
      res = await api.post("/membretes/", payload);
      mostrarMensaje("success", "Membrete(s) guardado(s) correctamente");
    }

    // Guardar en la lista, sin abrir PDF automáticamente
    if (Array.isArray(res.data)) {
      setMembretes((prev) => [...res.data, ...prev]);
      res.data.forEach(m => estadosMembretesRef.current[m.id] = m.estado_pago_id);
    } else if (res.data?.id) {
      setMembretes((prev) => [res.data, ...prev]);
       estadosMembretesRef.current[res.data.id] = res.data.estado_pago_id;
    }

    setArchivoGenerado(null); // no abrir automáticamente
    mostrarMensaje("info", "Los membretes debe solo podrán descargarse cuando cambie su estado a 'pago' o 'fiao'.");

    setFiltroMembrete("");
    setPagina(1);
    await cargarMembretes();
    limpiarFormulario();
  } catch (error) {
    console.error("Error al guardar/actualizar membrete:", error);
    mostrarMensaje("danger", "Ocurrió un error al generar el membrete.");
  } finally {
    setLoading(false);
  }
};

  const limpiarFormulario = () => {
    setForm({ cliente_id: "", cita_id: "" });
    setEstado("");
    setTiposMembrete([]);
    setDireccionId(null);
    setObservaciones("");
    setMembreteEditando(null);
    setMotivo("");
    setArchivoGenerado(null);
    setCitasFiltradas([]);
    setFiltroNombre("");
    setEstadoDesdePagoNombre("");
  };

  const handleEditar = async (m) => {
    navigate("/pagos", {
      state: {
         membrete_id: m.id,
        cliente_id: m.cliente_id,
        cita_id: m.cita_id,
        estado_pago_id: m.estado_pago_id,
        tipos_membrete: m.tipo_membrete_id ? [m.tipo_membrete_id] : [],
        direccion_id: m.direccion_id || null,
        observaciones: m.observaciones || "",
      },
    });
    //setMembreteEditando(m);

    // Asegúrate de que los clientes ya estén cargados
    if (clientes.length === 0) {
      await cargarClientes();
    }

    // Asegúrate de que todas las citas ya estén cargadas
    if (citas.length === 0) {
      await cargarTodasLasCitas();
    }

    // Carga las citas de este cliente
    await cargarCitasPorCliente(m.cliente_id);

    // Forzar inclusión de cita actual en citasFiltradas
    const citaActual = citas.find((c) => c.id === m.cita_id);
    if (citaActual && !citasFiltradas.some((c) => c.id === m.cita_id)) {
      setCitasFiltradas((prev) => [...prev, citaActual]);
    }

    // Setear el form
    setForm({
      cliente_id: m.cliente_id?.toString() || "",
      cita_id: m.cita_id?.toString() || "",
    });

    // Mapear estado y tipo (IDs)
    setEstado(m.estado_pago_id ? String(m.estado_pago_id) : "");
    setTiposMembrete(m.tipo_membrete_id ? [m.tipo_membrete_id] : []);

    setDireccionId(m.direccion_id || "");
    setObservaciones(m.observaciones || "");

   
  const cliente = clientes.find(c => c.id === m.cliente_id);
  setForm({
    cliente_id: cliente ? cliente.id.toString() : "",
    cita_id: m.cita_id ? m.cita_id.toString() : ""
  });
  setMembreteEditando(m); // Guardamos el ID para saber que estamos editando
};

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar este membrete?")) return;
    await api.delete(`/membretes/${id}`);
    mostrarMensaje("danger", "Membrete eliminado");
    cargarMembretes();
  };

  const incluyeClienteInstitucionSeleccionado = useMemo(
    () => tiposMembrete.some((id) => esClienteInstitucion(id)),
    [tiposMembrete, tiposMembreteOpciones]
  );

  const descargarPDF = async (membrete) => {
  const estadoNombre = nombreEstado(membrete.estado_pago_id).toLowerCase();
  if (estadoNombre === "debe") {
    alert("No se puede descargar el PDF mientras el estado sea 'debe'. Cambie a 'pago' o 'fiao' primero.");
    return;
  }

  try {
    const res = await api.get(`/membretes/${membrete.id}/descargar`, {
      responseType: "blob" // Muy importante para archivos
    });

    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;

    const cliente = membrete.cliente_principal;
    const nombreCliente = cliente
      ? cliente.tipo_cliente_id === 1
        ? cliente.nombres
        : `${cliente.nombres}_${cliente.apellidos}`
      : "cliente";
    const fecha = new Date().toISOString().replace(/[:.]/g, "_");
    link.setAttribute('download', `membrete_${nombreCliente}_${fecha}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error descargando PDF:", error);
    alert(error.response?.data?.detail || "Error descargando PDF");
  }
};
const membretesFiltrados = useMemo(() => {
  return membretes.filter((m) => {
    // Filtrar por nombre o apellido del cliente
    const nombreCliente = m.cliente_principal
      ? `${m.cliente_principal.nombres} ${m.cliente_principal.apellidos}`.toLowerCase()
      : "";
    const matchNombre = nombreCliente.includes(filtroMembrete.toLowerCase());

    // Filtrar por fecha
    const matchFecha = filtroFecha
      ? m.fecha?.startsWith(filtroFecha)
      : true;

    // Filtrar por tipo de membrete
    const matchTipo = filtroTipo
      ? m.tipo_membrete_id === parseInt(filtroTipo)
      : true;

    return matchNombre && matchFecha && matchTipo;
  });
}, [membretes, filtroMembrete, filtroFecha, filtroTipo]);

    return (
    <div className="card p-4">
      <h3 className="text-primary">Generar Ticket</h3>
      {mensaje && (
  <div className={`alert alert-${mensaje.tipo} mt-3`} role="alert">
    {mensaje.texto}
  </div>
      )}

   

      <div className="mb-3 p-3 border rounded">
        <h5>Procesar Lote del Día</h5>
        <Row>
          <Col md={2}>
            <Form.Label>Fecha</Form.Label>
            <Form.Control
              type="date"
              value={fechaLote}
              onChange={(e) => setFechaLote(e.target.value)}
            />
          </Col>
          <Col md={2}>
            <Form.Label>Institución (opcional)</Form.Label>
            <Form.Select
              value={institucionIdLote}
              onChange={(e) => setInstitucionIdLote(e.target.value)}
            >
              <option value="">Todas</option>
              {direcciones.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.nombre}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <div className="d-flex gap-2 mt-2">
          
          <Button onClick={handleDescargarPDFUnico}>Descargar PDF Lote</Button>
        </div>
      </div>

     

      <h5 className="mt-4">Lista de Tickets Generados</h5>
      <Row className="mb-2">
       <Col xs={12} md={3}>
      <Form.Control
       
        type="text"
        placeholder="Buscar por nombre o apellido"
        value={filtroMembrete}
        onChange={(e) => {
          setPagina(1);
          setFiltroMembrete(e.target.value);
        }}
        className="mb-3"
      />
      </Col>
      <Col xs={12} md={3}>
  <Form.Label>Filtrar por Fecha</Form.Label>
  <Form.Control
    type="date"
    value={filtroFecha}
    onChange={(e) => {
      setPagina(1);
      setFiltroFecha(e.target.value);
    }}
  />
</Col>
<Col xs={12} md={3}>
  <Form.Label>Filtrar por Tipo</Form.Label>
  <Form.Select
    value={filtroTipo}
    onChange={(e) => {
      setPagina(1);
      setFiltroTipo(e.target.value);
    }}
  >
    <option value="">Todos</option>
    {tiposMembreteOpciones.map((t) => (
      <option key={t.id} value={t.id}>{t.nombre}</option>
    ))}
  </Form.Select>
</Col>
</Row>
      <div className="table-responsive">
      <Table striped bordered hover >
        <thead>
          <tr>
            <th>ID</th>
            <th>Cliente</th>
            <th>Cita ID</th>
            <th>Estado</th>
            <th>Tipo</th>
            <th>Observaciones</th>
            <th>Fecha</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {membretesFiltrados.map((m) => (
            <tr key={m.id}>
              <td>{m.id}</td>
              <td>
                {m.cliente_principal
                  ? `${m.cliente_principal.nombres || ""} ${m.cliente_principal.apellidos || ""}`
                  : `ID: ${m.cliente_id}`}
              </td>
              <td>{m.cita_id}</td>
              <td>{nombreEstado(m.estado_pago_id)}</td>
              <td>{nombreTipo(m.tipo_membrete_id)}</td>
              <td>{m.observaciones}</td>
              <td>
                {m.fecha ? new Date(m.fecha).toLocaleString() : "Sin fecha"}
              </td>
              <td>
                <button
  onClick={() => descargarPDF(m)}
  className="btn btn-sm"
  style={{
    backgroundColor: "#1cc88a",
    borderColor: "#4e73df",
    color: "#fff",
  }}
>
  📄 PDF
</button>

<button
  onClick={() => handleEditar(m)}
  className="btn btn-sm"
  style={{
    backgroundColor: "#4e73df",
    borderColor: "#1cc88a",
    color: "#fff",
  }}
>
  ✏ Editar
</button>
               
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>

        {/* Paginación */}
              <div className="d-flex justify-content-between align-items-center mt-3">
                <Button variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>← Anterior</Button>
                <span>Página {pagina} de {totalPaginas}</span>
                <Button variant="secondary" disabled={pagina === totalPaginas} onClick={() => setPagina(p => p + 1)}>Siguiente →</Button>
        </div>

     
    </div>
  );
};

export default GenerarMembrete;